import React, { Fragment, useState } from "react";
import styled from "@emotion/styled";

const Label = styled.label`
  font-family: "Bebas Neue", cursive;
  font-weight: bold;
  font-size: 2.4rem;
  color: #fff;
  text-transform: uppercase;
  margin-top: 2rem;
  display: block;
`;
const Select = styled.select`
  width: 100%;
  display: block;
  padding: 1rem;
  -webkit-appearance: none;
  border-radius: 10px;
  border: none;
  font-size: 1.2rem;
`;

const useCryptoCurrency = (label, stateInicial, option) => {
  const [state, setCurrency] = useState(stateInicial);
  const SelectCrypto = () => (
    <Fragment>
      <Label>{label}</Label>
      <Select onChange={(e) => setCurrency(e.target.value)} value={state}>
        <option value="">--Seleccione--</option>
        {option.map((option) => (
          <option key={option.CoinInfo.Id} value={option.CoinInfo.Name}>
            {option.CoinInfo.FullName}
          </option>
        ))}
      </Select>
    </Fragment>
  );
  return [state, SelectCrypto, setCurrency];
};

export default useCryptoCurrency;
